import React from 'react';
import ImageAnswerTranslationItem from "../../Data/ImageAnswerTranslationItem";

export interface ImageAnswerProps {
    imageAnswerData: ImageAnswerTranslationItem | undefined,
    nameValue: string,
    imageAltValue: string | null,
    onClick?: () => void;
    onKeyboardPress?: (event : any) => void;
}

const tabIndex = 0;

export const ImageAnswerComponent: React.FC<ImageAnswerProps> = ({imageAnswerData, imageAltValue, nameValue, onClick, onKeyboardPress}) => {
    
    if(!imageAnswerData) return <></>;
    const imageAnswer = imageAnswerData as ImageAnswerTranslationItem;
    
    
    return (
        <div className="col zoopass--image-answer-wrapper radio">
            <div className="h-100 radio radio--wrapped radio--vertical radio--white mx-2">
                <label onClick={onClick} onKeyUpCapture={onKeyboardPress} className="h-100 d-inline-flex d-md-block zoopass--selectable radio__label-content" tabIndex={tabIndex}>
                    <div className="d-block order-1 order-md-0 h-100">
                        <svg width="40" height="40" className="mt-4">
                            <image xlinkHref={imageAnswer.getImageUrl()} width="40" height="40"/>
                        </svg>
                        {imageAnswer.title == null ? ('') : (
                            <h6 className="text-md-center px-1">{imageAnswer.title}</h6>)}
                        {imageAnswer.description == null ? ('') : (
                            <p className="text-md-center px-1" dangerouslySetInnerHTML={{__html: imageAnswer.description}}></p>)}
                    </div>
                    <input type="radio" name={nameValue} className="order-0 order-md-1 mx-auto d-none"/>
                </label>
            </div>
        </div>
    );
}